export default {
  name: 'sampleLifeEventTheme',
  uniqKey: '_id',
  crudMapping: {
    readMany: 'sampleLifeEventThemes',
    readOne: 'sampleLifeEventTheme',
    update: 'updateSampleLifeEventTheme',
  },
  readManySchema: {
    cellFormatter(value, object, fieldName) {
      return value;
    },
    jsonSchema: {
      type: 'object',
      properties: {
        title: {
          type: 'string',
        },
      },
    },
  },
  defaultSchema: {
    jsonSchema: {
      title: 'Life Event Theme',
      type: 'object',
      required: ['title', 'image'],
      properties: {
        title: {
          type: 'string',
        },
        description: {
          type: 'string',
          description:
            'Enter the description for this life event theme. This field has a 280 character limit.',
          maxLength: 280,
        },
        image: {
          type: 'string',
        },
      },
    },
    uiSchema: {
      image: {
        'ui:widget': 'imageWidget',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/schemas/admin/sampleLifeEventTheme.js